module.exports = __webpack_public_path__ + "img/home_bg.4f6cb194.png";